var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section__contact" }, [
    _vm.message
      ? _c("div", { staticClass: "section__contact--message" }, [
          _c("h3", { domProps: { innerHTML: _vm._s(_vm.message) } }),
        ])
      : _c(
          "div",
          { staticClass: "section__contact--form" },
          [
            _c("ValidationObserver", {
              ref: "form",
              staticClass: "form",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit }) {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "ajax-container",
                          attrs: { "data-loading": _vm.loading },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return handleSubmit(_vm.submitForm)
                            },
                          },
                        },
                        [
                          _c("table", { staticClass: "form-table" }, [
                            _c("tbody", [
                              _c(
                                "tr",
                                { attrs: { valign: "top" } },
                                [
                                  _c(
                                    "th",
                                    {
                                      staticClass: "titledesc",
                                      attrs: { scope: "row" },
                                    },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "woo-bg-name" } },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.i18n.name) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    staticClass: "forminp forminp-text",
                                    attrs: { tag: "td", rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.fields.name,
                                                    expression: "fields.name",
                                                  },
                                                ],
                                                attrs: {
                                                  name: "woo-bg-name",
                                                  type: "text",
                                                },
                                                domProps: {
                                                  value: _vm.fields.name,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.fields,
                                                      "name",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                { staticClass: "field-error" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "tr",
                                { attrs: { valign: "top" } },
                                [
                                  _c(
                                    "th",
                                    {
                                      staticClass: "titledesc",
                                      attrs: { scope: "row" },
                                    },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "woo-bg-name" } },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.i18n.email) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    staticClass: "forminp forminp-text",
                                    attrs: { tag: "td", rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.fields.email,
                                                    expression: "fields.email",
                                                  },
                                                ],
                                                attrs: {
                                                  name: "woo-bg-name",
                                                  type: "text",
                                                },
                                                domProps: {
                                                  value: _vm.fields.email,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.fields,
                                                      "email",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                { staticClass: "field-error" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "tr",
                                { attrs: { valign: "top" } },
                                [
                                  _c(
                                    "th",
                                    {
                                      staticClass: "titledesc",
                                      attrs: { scope: "row" },
                                    },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "woo-bg-name" } },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.i18n.message) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    staticClass: "forminp forminp-text",
                                    attrs: { tag: "td", rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("textarea", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.fields.message,
                                                    expression:
                                                      "fields.message",
                                                  },
                                                ],
                                                attrs: { rows: "7" },
                                                domProps: {
                                                  value: _vm.fields.message,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.fields,
                                                      "message",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                { staticClass: "field-error" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "submit" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "button-primary woocommerce-save-button",
                                attrs: {
                                  name: "save",
                                  type: "submit",
                                  value: _vm.i18n.send,
                                },
                              },
                              [_vm._v(_vm._s(_vm.i18n.send))]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }